import styled from "styled-components";
import { Heading, Paragraph } from "../../atoms/Typography/Typography.styles";

export const UploadFormWrapper = styled.div`
  padding: ${({ theme }) => theme.rem(24)};
  width: 100%;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  aspect-ratio: 16 / 16;

  ${({ theme }) => theme.mediaQuery.xl(`
    aspect-ratio: 16 / 10;
  `)}

  ${Paragraph},
  ${Heading} {
    color: black;
  }
`

export const UploadFormInputFile = styled.input`
  display: none
`

export const UploadFormInputText = styled.input`
  width: ${({ theme }) => theme.rem(200)};
  padding-bottom: ${({ theme }) => theme.rem(8)};
  appearance: none;
  border: none;
  background: transparent;
  ${({ theme }) => theme.typo('paragraphLG')};
  border-bottom: 1px solid ${({ theme }) => theme.colorScheme['darkGreen'].surface.inside};
  text-align: center;

  ${({ theme }) => theme.mediaQuery.xl(`
    width: ${theme.rem(380)};
  `)}
`;

export const UploadFormFakeInput = styled.label`
  width: ${({ theme }) => theme.rem(200)};
  aspect-ratio: 16 / 9;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.rem(24)};
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='25' ry='25' stroke='black' stroke-width='7' stroke-dasharray='5%2c 20' stroke-dashoffset='16' stroke-linecap='square'/%3e%3c/svg%3e");

  ${({ theme }) => theme.mediaQuery.xl(`
    width: ${theme.rem(380)};
  `)}
`

export const UploadFormIconWrapper = styled.div`
  i {
    font-size: ${({ theme }) => theme.rem(40)};
  }
`

export const DashedBorderWrapper = styled.div`
  width: 100%;
  min-height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  
`

export const UploadFormImagePreviewWrapper = styled.div`
  width: ${({ theme }) => theme.rem(200)};
  aspect-ratio: 16 / 9;
  border-radius: ${({ theme }) => theme.rem(24)};
  overflow: hidden;
  box-shadow: 0 ${({ theme }) => theme.rem(4)} ${({ theme }) => theme.rem(8)} rgba(0, 0, 0, 0.1);
  position: relative;

  
  ${({ theme }) => theme.mediaQuery.xl(`
    width: ${theme.rem(380)};
  `)}

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }
`

export const UploadFormCenterContent = styled.div`

`